module.exports = __webpack_public_path__ + "img/go-to-arrow.f8c881bb.svg";